import { Options } from 'vue-class-component';
import AssignRoomObjectGeneralStep from '../AssignRoomObjectGeneralStep';
import {
  getObjectIconFromType,
  getObjectDescLabel,
  getDeviceIconFromSettings,
  getDeviceIconName,
  hasDeviceCommandIconButtonVisible,
  hasDeviceSettingsButtonVisible,
  parseShutterActuatorSettings,
} from '@/core/utils/utils';
import { SET_APP_LOADING } from '@/core/store/action-types';
import deviceSettingsClient from '@/core/services/device-settings-service';
import { IDefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/device-settings';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import CommandIconComponent from '@/views/components/CommandIcon/CommandIconComponent.vue';
import ObjectSettings from '@/views/components/ObjectSettings/ObjectSettings.vue';
import { RoomObjectDTO } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'Step4',
  components: {
    CommandIconComponent,
    ObjectSettings,
  },
})
export default class Step4 extends AssignRoomObjectGeneralStep {
  getObjectIconFromType = getObjectIconFromType;
  getObjectDescLabel = getObjectDescLabel;
  getDeviceIconFromSettings = getDeviceIconFromSettings;
  getDeviceIconName = getDeviceIconName;
  hasDeviceSettingsButtonVisible = hasDeviceSettingsButtonVisible;
  hasDeviceCommandIconButtonVisible = hasDeviceCommandIconButtonVisible;

  showRightPanel = false;
  activeSettingsComponent = '';
  currentDefaultSetting: IDefaultDevicesSettingsDTO | null = null;
  currentDeviceName: string | null = null;

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      const response = await deviceSettingsClient.roomObjectDefault(
        this.roomObject.id!,
        RoomObjectDTO.fromJS(this.roomObject as any)
      );

      for (const deviceSetting of response) {
        parseShutterActuatorSettings(deviceSetting);
      }

      this.$emit('update:defaultSettings', response);
    } catch (error) {
      console.log(error);
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }
      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  openAdvancedSettings() {
    this.showRightPanel = true;
  }

  showDeviceSettings(setting: IDefaultDevicesSettingsDTO) {
    this.currentDefaultSetting = setting;
    this.showRightPanel = true;
    this.currentDeviceName = this.getDeviceName(setting.deviceUid as string);
  }

  showDeviceCommandIcon(setting: IDefaultDevicesSettingsDTO) {
    this.currentDefaultSetting = setting;
    this.showRightPanel = true;
    this.currentDeviceName = this.getDeviceName(setting.deviceUid as string);
    this.activeSettingsComponent = 'CommandIconComponent';
  }

  hideRightPanel() {
    this.currentDefaultSetting = null;
    this.showRightPanel = false;
    this.currentDeviceName = '';
  }

  getDeviceName(deviceUuid: string) {
    const device = this.roomObject.devices?.find((k) => k.uid === deviceUuid);
    if (!device) return '';
    return `${device.model} - ID ${device.id}`;
  }
}
